<script>
    import { link } from "svelte-routing";
    import { createForm } from "svelte-forms-lib";
    import { navigate } from "svelte-routing";
    import { onDestroy, onMount } from 'svelte';
    import { imask } from 'svelte-imask';
    import {
        activateMembership,
        createSubscriberRegister,
        deactivateMembership,
        getSubByToken,
        getSubscriber,
        updateSubscriber,
        handleCreateError, deleteSubscriber
    } from "../../../services/subscribersService";
    import CountrySearcher from "../../SearchBars/CountrySearcher.svelte";
    import PrefixSearcher from "../PrefixSearcher.svelte";
    import CitySearcher from "../../SearchBars/CitySearcher.svelte";
    import CapSearcher from "../../SearchBars/CapSearcher.svelte";
    import SubscriberFormTitle from "./SubscriberFormTitle.svelte";
    import GroupNameSearcher from "../../SearchBars/GroupNameSearcher.svelte";
    import { closeModal, openModal } from "svelte-modals";
    import { deleteMembershipById, updateMembership } from "../../../services/membershipService";
    import toast from "svelte-french-toast";
    import Select from "svelte-select";
    import InputField from "../InputField.svelte";
    import { getOptionalSelectValue } from "../../../utils/getOptionalSelectValue";
    import DateSearcher from "../../SearchBars/DateSearcher.svelte";
    import { dateToInputString } from "../../../utils/dateToInputString";
    import {
        getProvinceSelectList,
        getFilteredComuniList,
        generateFiscalCode,
        filterComuni
    } from "../../../utils/codiceFiscale";
    import { settings } from "../../../stores/settingsStore"
    import AlertModal from "../../Modal/AlertModal.svelte";
    import RadioButtons from "../../SearchBars/RadioButtons.svelte";
    import {
        groupTypeByAncestorCount,
        mappedProfessions,
        subscriberValidationSchema
    } from "../../../utils/subscribers";
    import MembershipInfo from "./MembershipInfo.svelte";
    import { isRootManager, isAdmin, isGroupManager, loggedUser } from "../../../stores/settingsStore";
    import { getCities, getCityByCode } from "../../../services/addressService";
    import { isUGSActive as isUGSActiveForBirthDate } from "../../../utils/isUGSActive";
    import DeleteButton from "../../Cards/DeleteButton.svelte";

    export let isBackOffice = false;
    export let isRenew = false;
    export let isEdit;

    const urlParams = new URLSearchParams(window.location.search);
    const subscriberId = urlParams.get('id');
    const year = urlParams.get('year') ? +urlParams.get('year') : $settings.subscriptionActiveYear;
    const tableFilters = urlParams.get('from'); // filters to restore when going back to the table

    function goBackToTable() {
        navigate(tableFilters ? `table?${tableFilters}` : "table", { replace: true });
    }
    const phoneMask = { mask: '000 000 0000' };
    const genderOptions = [
        { value: "MALE", label: "Uomo", id: "genderMaleOption" },
        { value: "FEMALE", label: "Donna", id: "genderFemaleOption" },
        { value: "OTHER", label: "Altro", id: "genderOtherOption" },
    ];
    const ugsOptions = [
        { value: "true", label: "SI", id: "isUGSOption" },
        { value: "false", label: "NO", id: "isNotUGSOption" },
    ];

    let isPressed = false;
    let zips;
    let subscriberEdit;
    let subscriberMaxBirthDate;
    let hasAcceptedTerms = false;

    const unsubscribeSettings = settings.subscribe((setting) => {
        if (!setting) {
            return;
        }

        const maxDate = new Date();
        maxDate.setFullYear(maxDate.getFullYear() - setting.registrationMinAge);
        subscriberMaxBirthDate = dateToInputString(maxDate);
    });

    const { form, handleChange, handleSubmit, errors , isValid} = createForm({
        initialValues: {
            firstName: "",
            lastName: "",
            birthPlace: "",
            birthProvince: "",
            birthDate: "",
            nationality: "Italia",
            gender: "MALE",
            fiscalCode: "",
            email: "",
            residenceAddress : {
                street: "",
                number: "",
                secondary: "",
                city: "",
                region: "",
                zip: "",
                province: "",
                country: "Italia",
            },
            phone: {
                code: "+39",
                number:  ""
            },
            profession: "",
            isUGS: "true",
            confirmEmail: "",
            groupId: "",
            membership: undefined
        },
        validationSchema: subscriberValidationSchema,
        onSubmit: (value) => {
            isPressed = true;
            const subscriber = JSON.parse(JSON.stringify(value));

            if (
                isEdit &&
                subscriber.membership.active === "true" &&
                (+subscriber.membership.paidAmount > $settings.maximumPayment || +subscriber.membership.paidAmount < getMinimumPayment(subscriber))
            ) {
                toast.error(`L'ammontare del pagamento deve essere compreso fra ${getMinimumPayment(subscriber)} e ${$settings.maximumPayment}`);
                isPressed = false;

                return;
            }

            if (isEdit && subscriber.membership.active === "true" && (!subscriber.membership.paidAt || (subscriber.membership.paidAmount == null))) {
                toast.error("Completa i dati sul pagamento");
                isPressed = false;

                return;
            }

            if (!isBackOffice && !hasAcceptedTerms) {
                toast.error("Accetta i termini prima di continuare");
                isPressed = false;

                return;
            }

            if (isEdit) {
                isPressed = false;
                openModal(AlertModal, {
                    title: `Modifica iscritto`,
                    message: `Vuoi modificare l'iscritto?`,
                    onConfirm: async () => {

                        try {
                            const { isUGS, groupId, ...parsed } = handleCreateFormSubmitValue({...subscriber});
                            await editSubscriber(parsed, subscriberId)

                            await saveMembershipEdits(
                                subscriberMb,
                                subscriber.membership,
                                getOptionalSelectValue(subscriber.groupId),
                                subscriber.isUGS === "true"
                            );

                            closeModal();
                            goBackToTable();
                        } catch (e) {
                            closeModal();
                        }
                    }
                });
                return;
            }

            if(!!subscriber?.confirmEmail && subscriber?.confirmEmail !== subscriber.email) {
                toast.error("Le due e-mail non coincidono");
                isPressed = false;
                return;
            }

            addSubscriber(handleCreateFormSubmitValue({...subscriber}));
        },
    });

    function handleCreateFormSubmitValue(formSubscriber) {
        const dto = JSON.parse(JSON.stringify(formSubscriber));

        dto.isUGS = dto.isUGS === "true";
        dto.groupId = getOptionalSelectValue(dto.groupId);
        dto.nationality = getOptionalSelectValue(dto.nationality);
        dto.phone.code = getOptionalSelectValue(dto.phone.code);
        dto.residenceAddress.country = getOptionalSelectValue(dto.residenceAddress.country);
        dto.residenceAddress.zip = getOptionalSelectValue(dto.residenceAddress.zip);
        dto.birthProvince = getOptionalSelectValue(dto.birthProvince);
        dto.residenceAddress.city = dto.residenceAddress.city?.value?.name ??
        dto.residenceAddress.city?.value ?? dto.residenceAddress.city;

        if(!!dto.birthPlace.label) {
            dto.birthPlace = dto.birthPlace.label;
        }

        if(dto.residenceAddress.country !== "Italia") {
            delete dto.residenceAddress.region;
            delete dto.residenceAddress.province;
        }

        delete dto.membership;

        return dto;
    }

    async function editSubscriber(subscriber, id) {
        try {
            await updateSubscriber(subscriber, id, year);
            toast.success("Iscritto modificato");
        } catch (err) {
            if (err.response.status === 403) {
                toast.remove();
                toast.error(err.response.data.message);
            } else {
                toast.error("Non è possibile modificare l'iscritto, errore " + err.toString());
            }

            throw err;
        } finally {
            isPressed = false;
        }
    }

    async function addSubscriber(subscriber) {
        createSubscriberRegister(subscriber, subscriber.groupId).then((resp) => {
            isPressed = false;

            if (!isBackOffice || isRenew) {
                const currentMb = resp.data.memberships.find(m => m.year === $settings.subscriptionActiveYear)

                saveUserData(resp.data.id, currentMb.isUGS);
                navigate(`/pagamento?id=${currentMb.id}`, {replace: true})
            } else {
                toast.success("Iscritto creato");
                navigate(`./edit?id=${resp.data.id}&year=${$settings.subscriptionActiveYear}`, {replace: true});
                isEdit = true;
            }
        }).catch((err) => {
            isPressed = false;
            handleCreateError(err, isBackOffice);
        });
    }

    function saveUserData(subscriberId, isUGS) {
        localStorage.setItem(process.env.SUBSCRIBER_ID, subscriberId);
        localStorage.setItem(process.env.IS_UGS, JSON.stringify({isUGS}));
    }

    async function saveMembershipEdits(currentMemberShip, editedMembership, groupId, isUGS) {
        // editedMembership.paidAt = (!!editedMembership.paidAt ? (new Date(editedMembership.paidAt)) : new Date());
        // attiva iscrizione
        if (!currentMemberShip.active && editedMembership.active) {
            await activateMembership(subscriberId, currentMemberShip.year, editedMembership.paidAmount, editedMembership.paidAt)
                .catch((err) => {
                    if(err?.response?.status === 500) {
                        toast.error(`Impossibile attivare la tessera, errore ${err.toString()}`);
                    }
                });
        }

        //disattiva iscrizione
        if(currentMemberShip.active && !editedMembership.active) {
            await deactivateMembership(subscriberId, currentMemberShip.year)
                .catch((err) => {
                    if(err?.response?.status === 500) {
                        toast.error(`Impossibile disattivare la tessera, errore ${err.toString()}`);
                    }
                });
        }

        if (currentMemberShip.active === editedMembership.active) {
            await updateMembership(currentMemberShip.id, {
                subscriberId: subscriberEdit.id,
                groupId,
                paidAmount: editedMembership.paidAmount ? +editedMembership.paidAmount : undefined,
                paidAt : editedMembership.paidAt ?? undefined,
                isUGS
            }).catch((err) => {
                toast.error(`Impossibile modificare la tessera, errore ${err?.response?.data?.message.toString()}`, {  });
            });
        }
    }

    function tokenInvalidError() {
        toast.error("Inserisci la tua mail per rinnovare l'iscrizione");
        navigate("/rinnovo/login");
    }

    function verifyToken(token) {
        getSubByToken(token).then((res) => {
            if(res?.status !== 200) {
                tokenInvalidError();
                return;
            }

            subscriberEdit = { ...res.data };
            initForm();
        }).catch(() => tokenInvalidError())
    }

    function generateAndUpdateFiscalCode() {
        $form.fiscalCode = generateFiscalCode({...$form});
        $errors.fiscalCode = "";
    }

    function handleGenderChange(e) {
        handleChange(e)
        if (!$form.fiscalCode) {
            return;
        }

        if (!isFiscalCodeGeneratorDisabled) {
            generateAndUpdateFiscalCode()
        }
    }

    function handleChangeCityInput(value) {
        $errors.residenceAddress = {
            ...$errors.residenceAddress,
            city: "",
            zip: "",
        }

        zips = value.detail.value.zip.map((e) => ({value: e, label: e}));

        $form.residenceAddress = {
            ...$form.residenceAddress,
            zip: zips[0],
            region: $form.residenceAddress.city.value.region,
            province: $form.residenceAddress.city.value.province,
            code: $form.residenceAddress.city.value.code,
        }
    }

    function handleChangeZip(event) {
        if (!!event?.detail?.value) {
            $errors.residenceAddress = {
                ...$errors.residenceAddress,
                zip: ""
            }
        }
    }

    function handleChangeState() {
        $form.residenceAddress = {
            ...$form.residenceAddress,
            province: "",
            code: "",
            city: "",
            zip: ""
        }
        zips = [];
    }

    function clearBirthPlace(addError = false) {
        $form.birthPlace = null;

        if (addError) {
            $errors.birthPlace = "Inserisci un valore";
        }
    }

    function handleChangeBirthProvince(value) {
        clearBirthPlace();

        $errors.birthProvince = !!value ? "" : "Inserisci un valore";
    }

    function handleChangeBirthPlace(value) {
        $errors.birthPlace = !!value ? "" : "Inserisci un valore";
    }

    function handleChangeBirthDate() {
        if ($form.birthDate === undefined || !$settings) {
            $errors.birthDate = "Inserisci un valore";
            return;
        }

        $errors.birthDate = "";

        if (isUGSActive()) {
            if (!isBackOffice) {
                $form.paidAmount = Math.max($settings.minimumPaymentUGS, $form.paidAmount);
                $form.isUGS = undefined;
            }
        } else {
            if (!isBackOffice) {
                $form.paidAmount = Math.max($settings.minimumPaymentNotUGS, $form.paidAmount);
            }

            $form.isUGS = false;
        }
    }

    function initForm(city) {
        const { memberships, ...sub } = subscriberEdit;

        const group = subscriberMbGroup &&
            groupTypeByAncestorCount.find(g => g.match(subscriberMbGroup?.ancestorsCount)).value === "Circolo" ?
            { label: subscriberMbGroup.name, value: subscriberMbGroup.id } : undefined;

        if (!!city) {
            zips = city.zip.map((e) => ({value: e, label: e}));
        }

        $form = {
            ...sub,
            // The city must keep the same shape produced by CitySearcher, otherwise the
            // municipality id needed by the circolo searcher is not available.
            residenceAddress: !!city ? {
                ...sub.residenceAddress,
                city: { label: `${city.name} - ${city.province}`, value: city },
                // Realign the belfiore code: it may be missing on subscribers
                // imported or created before it was tracked.
                code: city.code,
            } : sub.residenceAddress,
            groupId: group,
            isUGS: subscriberMb?.isUGS ? "true" : "false",
            membership: isRenew ? undefined : {
                id: subscriberMb.id,
                active: subscriberMb.active,
                paidAmount: subscriberMb.paidAmount,
                paidAt: subscriberMb.paidAt,
                paymentMethod: subscriberMb.paymentMethod,
                subscriberId: subscriberMb.subscriberId,
                year: subscriberMb.year,
                tranId: subscriberMb.tranId,
                paymentId: subscriberMb.paymentId,
                shopId: subscriberMb.shopId,
                code: subscriberMb.code,
            }
        }
    }

    function getMinimumPayment(formData) {
        return formData.isUGS === "true" ? $settings.minimumPaymentUGS : $settings.minimumPaymentNotUGS
    }

    async function getSubscriberAndInitForm() {
        try {
            const res = await getSubscriber(subscriberId);
            subscriberEdit = {...res.data};

            const city = await getAddressCityCode({...subscriberEdit.residenceAddress});

            delete subscriberEdit.tokenExpiresAt;
            delete subscriberEdit.token;
            delete subscriberEdit.facilitatorId;

            if (isEdit) {
                initForm(city);
            } else {
                const {memberships, ...sub} = res.data;
                $form = {
                    ...sub,
                    isUGS: subscriberMb?.isUGS ? "true" : "false",
                }
            }
        } catch (err) {
            if(err?.response?.status === 404) {
                toast.error(`Iscritto non trovato`);
            }

            if(err?.response?.status === 500) {
                toast.error(`Errore durante la ricerca dell'iscritto`);
            }

            if (isBackOffice) {
                navigate("/admin/subscribers/");
            }
        }
    }

    async function getAddressCityCode(address) {
        if (address.country !== "Italia") {
            return null;
        }

        if (!!address.code) {
            try {
                return (await getCityByCode(address.code)).data;
            } catch (e) {
                // The code is missing from the municipalities: fall back to the name.
            }
        }

        return await getCityByAddressName(address);
    }

    // Subscribers imported or created before the belfiore code was tracked have no
    // usable code: without the municipality the circolo can't be chosen, so look it
    // up by name and province.
    async function getCityByAddressName(address) {
        if (!address.city) {
            return null;
        }

        try {
            const { data } = await getCities(address.city);
            const cities = data?.filter((city) => city.name.toLowerCase() === address.city.toLowerCase());
            const city = cities?.find((city) => city.province === address.province) ?? cities?.[0];

            if (!city) {
                toast.error(`Città ${address.city} non trovata`);
            }

            return city ?? null;
        } catch (e) {
            toast.error(`Città ${address.city} non trovata`);
            return null;
        }
    }

    async function handleDeleteSubscriber(id) {
        deleteSubscriber(id).then(() => {
            toast.success("Iscritto eliminato");
            goBackToTable();
        }).catch((err) => {
            handleError(err);
        })
    }

    async function handleDeleteMb(id) {
        deleteMembershipById(id).then(() => {
            toast.success("Iscritto eliminato");
            goBackToTable();
        }).catch((err) => {
            handleError(err);
        })
    }

    onMount(async () => {
        if (isRenew) {
            const token = urlParams.get('token');
            if(!token){
                tokenInvalidError();
                return;
            }

            verifyToken(token);
            return;
        }

        if(isEdit || isBackOffice && !!subscriberId) {
            await getSubscriberAndInitForm();
        }
    });

    onDestroy(unsubscribeSettings);

    $: isFiscalCodeGeneratorDisabled = !$form.firstName || !$form.lastName || !$form.gender || !$form.birthDate || !$form.birthProvince || !$form.birthPlace;
    $: isUGSActive = () => isUGSActiveForBirthDate($form.birthDate, $settings?.ugsMaxAgeInclusive);
    $: isItaly = () => getOptionalSelectValue($form.residenceAddress.country) === "Italia";
    $: subscriberMb = subscriberEdit?.memberships?.find(mb => mb.year === year);
    $: subscriberMbGroup = subscriberMb?.group;
</script>

<div class="h-auto {isBackOffice ? 'bg-white p-4' : ''} relative flex flex-col min-w-0 break-words w-full gap-2">
    {#if isEdit || !$settings.disableSubscriptions}
        {#if isBackOffice}
            <SubscriberFormTitle
                id={subscriberId}
                isEdit={isEdit}
                isRenew={isRenew}
            />
        {/if}
        <form on:submit|preventDefault={handleSubmit}>
            <div class="flex flex-col justify-between w-full h-full gap-3">
                <div class="flex flex-col gap-3">
                    <div>
                        <div class="text-lg {isBackOffice ? 'font-450' : 'text-label'}">
                            {#if isBackOffice}
                                Nominativo
                            {:else }
                                Come ti chiami?
                            {/if}
                        </div>

                        <div class="flex flex-col md:flex-row gap-3">
                            <InputField
                                name="firstName"
                                hasLabel={false}
                                placeholder="Nome"
                                handleChange={handleChange}
                                isDisabled={((isEdit && !($isRootManager || $isAdmin)) || isRenew)}
                                bind:value={$form.firstName}
                                bind:errorText={$errors.firstName}
                            />

                            <InputField
                                name="lastName"
                                hasLabel={false}
                                placeholder="Cognome"
                                isRequired={false}
                                isDisabled={((isEdit && !($isRootManager || $isAdmin)) || isRenew)}
                                handleChange={handleChange}
                                bind:value={$form.lastName}
                                bind:errorText={$errors.lastName}
                            />
                        </div>
                    </div>

                    <div>
                        <span class="text-lg {isBackOffice ? 'font-450' : 'text-label'}">
                            {#if isBackOffice}
                                Luogo di nascita
                            {:else }
                                Dove sei nat*?
                            {/if}
                        </span>

                        <div class="flex flex-col md:flex-row gap-3">
                            <div class="w-full md:w-1/2">
                                <Select
                                    items={getProvinceSelectList()}
                                    id="birthProvince"
                                    type="text"
                                    placeholder="Provincia di nascita"
                                    class="select-error-border"
                                    containerStyles="width: 100%; box-shadow: 0px 1px 4px 0px rgb(0 0 0 / 15%); border-radius: 0px; height: 2.75rem"
                                    bind:hasError={$errors.birthProvince}
                                    bind:value={$form.birthProvince}
                                    on:handleClear={() => clearBirthPlace(true)}
                                    on:input={(e) => handleChangeBirthProvince(e?.detail?.value)}
                                />

                                <div class="pl-3 text-red-500">{$errors.birthProvince}</div>
                            </div>

                            <div class="w-full md:w-1/2">
                                <Select
                                    items={getFilteredComuniList()}
                                    itemFilter="{(label, filterText, option) => filterComuni(label, filterText, option, $form.birthProvince?.value)}"
                                    disabled="{!$form.birthProvince}"
                                    type="text"
                                    placeholder="Luogo di nascita"
                                    class="hover:shadow-md transition-all select-error-border"
                                    containerStyles="width: 100%; box-shadow: 0px 1px 4px 0px rgb(0 0 0 / 15%); border-radius: 0px; height: 2.75rem"
                                    bind:hasError={$errors.birthPlace}
                                    bind:value={$form.birthPlace}
                                    on:input={(e) => handleChangeBirthPlace(e?.detail?.value)}
                                />

                                <div class="pl-3 text-red-500">{$errors.birthPlace}</div>
                            </div>
                        </div>
                    </div>

                    <!--Data di nascita -->
                    <div>
                        <div class="text-lg {isBackOffice ? 'font-450' : 'text-label'}">
                            {#if isBackOffice}
                                Data di nascita
                            {:else }
                                Quando sei nat*?
                            {/if}
                        </div>

                        <DateSearcher
                            name="birthDate"
                            handleChange={handleChangeBirthDate}
                            placeholder="Inserisci la data di nascita (gg/mm/aaaa)"
                            maxDateString={subscriberMaxBirthDate}
                            isDisabled={((isEdit && !($isRootManager || $isAdmin)) || isRenew)}
                            bind:value={$form.birthDate}
                            bind:errorText={$errors.birthDate}
                        />

                    </div>

                    <!--  genere  -->
                    {#if (isEdit && ($isRootManager || $isAdmin)) || !isEdit}
                        <div>
                            <div class="text-lg {isBackOffice ? 'font-450' : 'text-label'}">Genere</div>

                            <RadioButtons
                                name="gender"
                                isNullable={false}
                                options={genderOptions}
                                handleChange={handleGenderChange}
                                bind:inputValue={$form.gender}
                            />
                        </div>
                    {/if}

                    <div>
                        <div class="text-lg {isBackOffice ? 'font-450' : 'text-label'}">
                            Codice Fiscale
                        </div>
                        <div class="flex flex-col md:flex-row md:h-11 gap-3 items-center">
                            <InputField
                                name="fiscalCode"
                                placeholder="Codice fiscale dell'iscritto"
                                containerClass="w-full h-11"
                                isRequired={false}
                                handleChange={handleChange}
                                bind:value={$form.fiscalCode}
                                bind:errorText={$errors.fiscalCode}
                            />

                            <button
                                class="w-full md:w-auto bg-blueGray-50 font-bold shadow-sm outline-none focus:outline-none
                                hover:shadow-md px-6 h-11 disabled:opacity-30 transition-all duration-100 border"
                                disabled={isFiscalCodeGeneratorDisabled}
                                on:click|preventDefault={generateAndUpdateFiscalCode}
                            >
                                GENERA
                            </button>
                        </div>
                    </div>

                    <div>
                        <div class="text-lg {isBackOffice ? 'font-450' : 'text-label'}">
                            Nazionalità
                        </div>

                        <div class="h-11">
                            <CountrySearcher
                                required={true}
                                placeholder="Nazionalità"
                                name="nationality"
                                bind:value={$form.nationality}
                            />
                        </div>
                    </div>


                    <div class="flex flex-col gap-3">
                        <!--   Stato  -->
                        <div class="w-full">
                            <div class="text-lg {isBackOffice ? 'font-450' : 'text-label'}">
                                {#if isBackOffice}
                                    Residenza
                                {:else }
                                    Dove abiti?
                                {/if}
                            </div>

                            <CountrySearcher
                                handleChange={handleChangeState}
                                required={true}
                                placeholder="Stato"
                                name="residenceAddress.country"
                                bind:value={$form.residenceAddress.country}
                            />
                        </div>

                        <div class="w-full flex flex-col gap-3 md:flex-row">
                            <div class="w-full md:w-8/12">
                                {#if isItaly()}
                                    <CitySearcher
                                        bind:value={$form.residenceAddress.city}
                                        bind:error={$errors.residenceAddress.city}
                                        groupId="{ $isGroupManager ? $loggedUser.groupId : undefined }"
                                        handleChange={(value) => handleChangeCityInput(value)}
                                        required={false}
                                    />
                                {:else}
                                    <InputField
                                        name="residenceAddress.city"
                                        hasLabel={false}
                                        placeholder="Nome della città"
                                        handleChange={handleChange}
                                        bind:value={$form.residenceAddress.city}
                                        bind:errorText={$errors.residenceAddress.city}
                                    />
                                {/if}
                            </div>

                            <div class="w-full md:w-4/12">
                                {#if isItaly()}
                                    <CapSearcher
                                        placeholder={isItaly() ? "Scegli il tuo CAP" : "Scegli il tuo ZIP"}
                                        handleChange={(value) => handleChangeZip(value)}
                                        required={false}
                                        name="residenceAddress.zip"
                                        bind:value={$form.residenceAddress.zip}
                                        bind:error={$errors.residenceAddress.zip}
                                        clearable={false}
                                        {zips}
                                    />
                                {:else }
                                    <InputField
                                        name="residenceAddress.zip"
                                        hasLabel={false}
                                        placeholder="CAP/ZIP della città"
                                        handleChange={handleChange}
                                        bind:value={$form.residenceAddress.zip}
                                        bind:errorText={$errors.residenceAddress.zip}
                                        isRequired={false}
                                    />
                                {/if}
                            </div>
                        </div>

                        <div class="w-full flex flex-col gap-3 md:flex-row">
                            <div class="w-full md:w-8/12">
                                <InputField
                                    name="residenceAddress.street"
                                    hasLabel={false}
                                    placeholder="Indirizzo"
                                    handleChange={handleChange}
                                    bind:errorText={$errors.residenceAddress.street}
                                    bind:value={$form.residenceAddress.street}
                                />
                            </div>
                            <div class="w-full md:w-4/12">
                                <InputField
                                    name="residenceAddress.number"
                                    hasLabel={false}
                                    placeholder="Numero civico"
                                    handleChange={handleChange}
                                    bind:value={$form.residenceAddress.number}
                                    bind:errorText={$errors.residenceAddress.number}
                                />
                            </div>
                        </div>

                        <InputField
                            hasLabel={false}
                            placeholder="Scala / Palazzo / Settore"
                            bind:value={$form.residenceAddress.secondary}
                        />
                    </div>

                    <!--  Email  -->
                    <div>
                        <div class=" text-lg {isBackOffice ? 'font-450' : 'text-label'}">
                            Indirizzo e-mail
                        </div>

                        <InputField
                            name="email"
                            hasLabel={false}
                            placeholder="E-mail"
                            type="email"
                            isDisabled="{((isEdit && !($isRootManager || $isAdmin)) || isRenew)}"
                            handleChange={handleChange}
                            bind:errorText={$errors.email}
                            bind:value={$form.email}
                        />
                    </div>

                    <!--  Ripeti email solo alla prima iscrizione  -->
                    {#if !isBackOffice && !isRenew}
                        <div>
                            <div class="text-lg {isBackOffice ? 'font-450' : 'text-label'}">
                                Ripeti indirizzo e-mail
                            </div>

                            <InputField
                                name="confirmEmail"
                                hasLabel={false}
                                placeholder="Ripeti e-mail"
                                type="email"
                                bind:value={$form.confirmEmail}
                                bind:errorText={$errors.confirmEmail}
                            />
                        </div>
                    {/if}


                    <!--  Numero di telefono  -->
                    <div>
                        <div class="text-lg {isBackOffice ? 'font-450' : 'text-label'}">
                            Numero di telefono
                        </div>
                        <div class="w-full flex flex-col gap-3 md:flex-row">
                            <div class="w-full md:w-4/12 h-11">
                                <PrefixSearcher
                                    bind:value={$form.phone.code}
                                    handleChange={() => handleChange}
                                    required={false}
                                />
                            </div>
                            <input
                                placeholder="Numero di telefono"
                                name="phone.number"
                                type="tel"
                                class=" w-full md:w-8/12 h-11 input-home transition-all"
                                use:imask={ phoneMask }
                                id="phone.number"
                                maxlength="15"
                                on:change={handleChange}
                                on:blur={handleChange}
                                bind:value={$form.phone.number}
                            />
                        </div>

                        <div class="pl-3 text-red-500">{$errors.phone.number}</div>
                    </div>

                    <div>
                        <div class="text-lg {isBackOffice ? 'font-450' : 'text-label'}">
                            Professione
                        </div>

                        <select
                            class="w-full input-home outline-none h-11 focus:outline-none"
                            name="profession"
                            bind:value={$form.profession}
                            on:change={handleChange}
                            class:border-error={$errors.profession}
                        >
                            <option selected disabled class="text-gray-500">Seleziona una professione</option>
                            {#each mappedProfessions as profession}
                                <option value={profession.value}>{profession.label}</option>
                            {/each}
                        </select>

                        <div class="pl-3 text-red-500">{$errors.profession}</div>
                    </div>

                    <div>
                        <div class="block  text-lg {isBackOffice ? 'font-450' : 'text-label'}">
                            {#if isBackOffice}
                                Circolo
                            {:else }
                                Scegli, se vuoi, il circolo della tua provincia di cui far parte
                            {/if}
                        </div>
                        <div class="w-full h-11">
                            <GroupNameSearcher
                                bind:value={$form.groupId}
                                municipalityId={$form.residenceAddress.city?.value?.id}
                            />
                        </div>
                    </div>

                    <!--Is ugs-->
                    {#if isUGSActive()}
                        <div>
                            <div class="text-lg {isBackOffice ? 'font-450' : 'text-label'}">
                                {#if isBackOffice}
                                    Partecipazione a UGS
                                {:else }
                                    Vuoi far parte dell'Unione Giovani di Sinistra (UGS)?
                                {/if}
                            </div>

                            <RadioButtons
                                name="isUGS"
                                options={ugsOptions}
                                isNullable={false}
                                handleChange={handleChange}
                                bind:inputValue={$form.isUGS}
                                bind:errorText={$errors.isUGS}
                            />
                        </div>
                    {/if}

                    {#if isEdit && !!$form && !!$form.membership}
                        <MembershipInfo
                            {$isAdmin}
                            {$isRootManager}
                            {subscriberId}
                            {handleChange}
                            name="membership"
                            bind:membership={$form.membership}
                            bind:errors={$errors.membership}
                        />
                    {/if}
                </div>

                {#if !isBackOffice}
                    <div class="w-full flex gap-2 items-center text-xl mt-2 pl-3">
                        <input type="checkbox" class="w-10 h-10 input-home" bind:checked={hasAcceptedTerms}>

                        <div>
                            Dichiaro di aver letto e di accettare l’ “<a use:link href="/policy" target="_blank" class="red-si bg-none cursor-pointer">
                            Informativa sul trattamento dei dati personali</a>”.
                            e di voler procedere all’iscrizione a Sinistra Italiana. (Se non accetti non ti sarà possibile procedere con l’iscrizione).
                        </div>
                    </div>
                {/if}

                <div class="button-container {isBackOffice ? 'w-26r' : ''} self-center">
                    <button
                        disabled={!$isValid || isPressed || (!isBackOffice && !hasAcceptedTerms)}
                        type="submit"
                        class="bg-lightBlue-400 py-2 text-white transition font-bold hover:shadow-lg disabled:opacity-30 focus:outline-none
                            {!isEdit ? 'w-52' : 'w-full'}
                            {!isBackOffice ? 'w-52 px-8 text-xl mb-4' : ''}"
                    >
                        { isBackOffice ? "Salva": "Continua" }
                    </button>

                    {#if $isAdmin && isEdit}
                        <div class="flex items-center justify-center gap-4 w-full">
                            <DeleteButton
                                message="Vuoi eliminare questa tessera?"
                                buttonClass="w-1/2"
                                buttonText="Elimina la tessera"
                                on:delete={() => handleDeleteMb(subscriberMb.id)}
                            />
                            <DeleteButton
                                message="Vuoi eliminare l'iscritto? Verranno eliminate anche tutte le sue precedenti iscrizioni."
                                buttonClass="w-1/2"
                                buttonText="Elimina l'iscritto"
                                on:delete={() => handleDeleteSubscriber(subscriberId)}
                            />
                        </div>
                    {/if}
                </div>
            </div>
        </form>
        {:else }
        <div class="h-full min-h-400-px flex justify-center items-center text-3xl si-font font-bold red-si">
            {$settings.disableSubscriptionsLabel}
        </div>
    {/if}
</div>

<style>
    .button-container {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        gap: 1rem;
    }

    .w-26r {
        width: 26rem;
    }
</style>